import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9k3bwv3ddx: FaireBrandEntity = {
  token: "b_9k3bwv3ddx",
  type: "brand",
  name: "A Scent Story Candle Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/b87fda36f3ed8ddc30bbd13fd7c3f4af9ad454f6ec114785515b60ecd0a00111.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9c8694e309e8b8b10c97c2d61f9ed38d2d9346d57fd3b388a6cf3d6304f9d1c5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b87fda36f3ed8ddc30bbd13fd7c3f4af9ad454f6ec114785515b60ecd0a00111.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9c8694e309e8b8b10c97c2d61f9ed38d2d9346d57fd3b388a6cf3d6304f9d1c5.jpeg",
  location: "Snellville , GA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 126,
  isInsider: true,
  description:
    "Hey There! \n\nHey There! My name is Leslie and I’ve been making candles since 2015. \n\nAt A Scent Story Candle Co., we’re book lovers who never want the story to end. You know that feeling—when you finish a great book and just want to stay in that world a little longer? We get it. And we’ve found that scent can bring you right back.\n\nSome stories just smell like something—maybe it’s a cozy library, a fresh forest, or warm baked goods from a magical little town. Our book-shaped and regular candles are made to capture those vibes and keep the feeling going, even after the last page.\n\nBecause sometimes, the best way to revisit your favorite stories… is to light a match.\n\n⸻\n\nSo settle in, light a candle and read awhile...",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:10.733Z",
    importedBy: "entity-db-cli",
  },
};
